import proxybase from './proxybase';

class MembersForms {
  newMembers(body) {
    return proxybase
      .post(`/members/newMembers`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  newMembersLookup(body) {
    return proxybase
      .post(`/members/newMembersLookup`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  newMembersReport(body) {
    return proxybase
      .post(`/members/newMembersReport`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  updateNewMembers(body) {
    return proxybase
      .put(`/members/newMembersReport`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  getAMember(body) {
    return proxybase
      .post(`/members/getAMember`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  guestLeaders(body) {
    return proxybase
      .post(`/members/guestLeaders`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  UpsertGuestLeaders(body) {
    return proxybase
      .post(`/members/UpsertGuestLeaders`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  counselingList(body) {
    return proxybase
      .post(`/members/counselingList`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  newCounseling(body) {
    return proxybase
      .post(`/members/newCounseling`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  updateCounseling(body) {
    return proxybase
      .post(`/members/updateCounseling`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  getLegadoDonations(body) {
    return proxybase
      .post(`/members/getLegadoDonations`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  // Manual Payments Endpoints
  addManualDonation(body) {
    return proxybase
      .post(`/members/manualPayments`, body)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }
  updateManualDonation(body) {
    return proxybase
      .put(`/members/manualPayments`, body)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }
  deleteManualDonation({ id, guest_id }) {
    return proxybase
      .put(`/members/manualPayments`, { id, guest_id, deleted: true })
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }
}
const membersForms = new MembersForms();
export default membersForms;
